import React, { useContext, useState, useEffect } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getImages } from '../const';
import { VehicleContext } from '../Context/VehicleContext';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link, useNavigate } from 'react-router-dom';
import ValidationError from '../Errors/ValidationError';

const dropDowns = {};

dropDowns['residence_yata'] = Array.from({ length: 20 + 1 }, (_, i) => i);
dropDowns['residence_mata'] = Array.from({ length: 20 + 1 }, (_, i) => i);
dropDowns['residence_type'] = ['Rent','Own','Mortgage'];
dropDowns['residence_state'] = ['AK','AL','AR','AS','AZ','CA','CO','CT','DC','DE','FL','GA','GU','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MP','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UM','UT','VA','VI','VT','WA','WI','WV','WY'];

dropDowns['employment_occupation'] = ['Healthcare (Practitioners, Technical, and Support)','Business, Executive, Management, and Financial','Architecture and Engineering','Education, Training, and Library','Other Professional Occupations','Office and Administrative Support','Services','Agriculture, Maintenance, Repair, and Skilled Crafts','Transportation','Other'];
dropDowns['employment_noyapj'] = Array.from({ length: 30 + 1 }, (_, i) => i);
dropDowns['employment_state'] = ['AK','AL','AR','AS','AZ','CA','CO','CT','DC','DE','FL','GA','GU','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MP','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UM','UT','VA','VI','VT','WA','WI','WV','WY'];

dropDowns['trade_in_type'] = ['Lease','Purchase'];
dropDowns['trade_in_vehicle_status'] = ['Open Financing','Paid Off'];

const FinanceDropDown = ({field}) => {
    return (
        <React.Fragment>
            <Field as="select" name={field} className='form-control'>
                <option>Select</option>
                {dropDowns && field in dropDowns && dropDowns[field].map((v,i) => (
                    <option key={i} value={v}>{v}</option>
                ))}
            </Field>
            <ErrorMessage name={field} component='div' className='text-danger' />
        </React.Fragment>
    )
}

const FinanceApplicationModal = ({close}) => {
    const navigate = useNavigate();
    const {submitContactForm, vehicleListSearch} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();
    
    const validationSchema = Yup.object().shape({
        first_name: Yup.string()
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        terms_agreement: Yup.boolean()
            .oneOf([true], 'You must agree to the terms'),
        //marketing_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information'),
        //marketing_info_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information')
    });

    const [vehicleMakes,setVehicleMakes] = useState([]);
    const [vehicleModels,setVehicleModels] = useState([]);

    const [vehicleYearData,setVehicleYearData] = useState([]);

    useEffect(() => {

        if(!vehicleMakes || vehicleMakes.length === 0) {

            getVehicleYearData(new Date().getFullYear());
        } 
    },[]);

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({'subject':'yeardata','year':year});
        console.log(data);

        setVehicleYearData(data);
        
        let makes = [];
        
        if('makes' in data) {
            data['makes'].map((make,i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year,make) => {        
        console.log(year,make);

        if('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].map((model,j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }


    return (
        <>
            <div className="modal-content">
                <div className="modal-body p-60-130">
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                    <div className='md-title font-1-9em fw-400 text-uppercase'>Finance Application</div>
                    
                    <Formik
                        initialValues={{
                            first_name: '',
                            email: '',
                            phone_number: '',
                            dob: '',
                            social_security: '',
                            driver_license: '',
                            license_exp_date: '',

                            residence_address: '',
                            residence_city: '',
                            residence_state: '',
                            residence_zip_code: '',
                            residence_yata: '',
                            residence_mata: '',
                            residence_type: '',
                            residence_monthly_payment: '',

                            employer: '',
                            employment_supervisor: '',
                            employment_address: '',
                            employment_city: '',
                            employment_state: '',
                            employment_zip_code: '',
                            employment_office_phone: '',
                            employment_gross_monthly_income: '',
                            employment_other_income: '',
                            employment_occupation: '',
                            employment_noyapj: '',

                            trade_in_type: '',
                            trade_in_vehicle_status: '',
                            co_applicant: '',

                            vehicle_make: '',
                            vehicle_model: '',
                            vehicle_stock: '',
                            vehicle_down_payment: '',

                            comments: '',
                            terms_agreement: true,
                            marketing_agreement: false,
                            marketing_info_agreement: false
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                                // alert("Thank you for your submission. We'll be in touch soon!");
                                close();
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue }) => (
                            <Form className='custom-form finance-form' >
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                />
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Personal Information</div>
                                    <div className='row mlr-40'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Full Name</div>
                                                    <div className='cs-require'><span className='text-orange'>*</span> Required</div>
                                                </div>
                                                <Field type="text" name='first_name' className='form-control' />
                                                <ErrorMessage name='first_name' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Email</div>
                                                    <div className='cs-require'><span className='text-orange'>*</span> Required</div>
                                                </div>
                                                <Field type="text" name='email' className='form-control' />
                                                <ErrorMessage name='email' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Phone Number</div>
                                                </div>
                                                <Field type="text" name='phone_number' className='form-control' />
                                                <ErrorMessage name='phone_number' component='div' className='text-danger' />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Date of Birth</div>
                                                    </div>
                                                    <Field type="text" name='dob' className='form-control' />
                                                    <ErrorMessage name='dob' component='div' className='text-danger' />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Social Security</div>
                                                    </div>
                                                    <Field type="text" name='social_security' className='form-control' />
                                                    <ErrorMessage name='social_security' component='div' className='text-danger' />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Driver License</div>
                                                    </div>
                                                    <Field type="text" name='driver_license' className='form-control' />
                                                    <ErrorMessage name='driver_license' component='div' className='text-danger' />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>License Exp Date</div>
                                                    </div>
                                                    <Field type="text" name='license_exp_date' className='form-control' />
                                                    <ErrorMessage name='license_exp_date' component='div' className='text-danger' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Residence Information</div>
                                    <div className='row mlr-40'>
                                        <div className='col-md-7'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Address</div>
                                                </div>
                                                <Field type="text" name='residence_address' className='form-control' />
                                                <ErrorMessage name='residence_address' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>City</div>
                                                </div>
                                                <Field type="text" name='residence_city' className='form-control' />
                                                <ErrorMessage name='residence_city' component='div' className='text-danger' />
                                            </div>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>State</div>
                                                    </div>
                                                    <FinanceDropDown field={'residence_state'} />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Zip Code</div>
                                                    </div>
                                                    <Field type="text" name='residence_zip_code' className='form-control' />
                                                    <ErrorMessage name='residence_zip_code' component='div' className='text-danger' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-5'>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Years at this address</div>
                                                    </div>
                                                    <FinanceDropDown field={'residence_yata'} />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Months at this address</div>
                                                    </div>
                                                    <FinanceDropDown field={'residence_mata'} />
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Residence Type</div>
                                                </div>
                                                <FinanceDropDown field={'residence_type'} />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Monthly Payment</div>
                                                </div>
                                                <Field type="text" name='residence_monthly_payment' className='form-control' placeholder="$0.00" />
                                                <ErrorMessage name='residence_monthly_payment' component='div' className='text-danger' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Employment Information</div>
                                    <div className='row mlr-40'>
                                        <div className='col-md-7'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Employer</div>
                                                </div>
                                                <Field type="text" name='employer' className='form-control' />
                                                <ErrorMessage name='employer' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Supervisor</div>
                                                </div>
                                                <Field type="text" name='employment_supervisor' className='form-control' />
                                                <ErrorMessage name='employment_supervisor' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Address</div>
                                                </div>
                                                <Field type="text" name='employment_address' className='form-control' />
                                                <ErrorMessage name='employment_address' component='div' className='text-danger' />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>City</div>
                                                </div>
                                                <Field type="text" name='employment_city' className='form-control' />
                                                <ErrorMessage name='employment_city' component='div' className='text-danger' />
                                            </div>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>State</div>
                                                    </div>
                                                    <FinanceDropDown field={'employment_state'} />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Zip Code</div>
                                                    </div>
                                                    <Field type="text" name='employment_zip_code' className='form-control' />
                                                    <ErrorMessage name='employment_zip_code' component='div' className='text-danger' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-5'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Office Phone</div>
                                                </div>
                                                <Field type="text" name='employment_office_phone' className='form-control' />
                                                <ErrorMessage name='employment_office_phone' component='div' className='text-danger' />
                                            </div>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Gross Monthly Income</div>
                                                    </div>
                                                    <Field type="text" name='employment_gross_monthly_income' className='form-control' />
                                                    <ErrorMessage name='employment_gross_monthly_income' component='div' className='text-danger' />
                                                </div>
                                                <div className='col-md-6 form-group'>
                                                    <div className='d-flex align-items-center justify-content-between mb-1'>
                                                        <div className='cs-label fw-300 mb-0'>Other Income</div>
                                                    </div>
                                                    <Field type="text" name='employment_other_income' className='form-control' />
                                                    <ErrorMessage name='employment_other_income' component='div' className='text-danger' />
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Occupation</div>
                                                </div>
                                                <FinanceDropDown field={'employment_occupation'} />
                                            </div>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Number of year at present job</div>
                                                </div>
                                                <FinanceDropDown field={'employment_noyapj'} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-4'>
                                        <div className='mnw-100'>
                                            <div className="custom-checkbox fin_app_chkbox mb-4">
                                                <Field
                                                    type="checkbox"
                                                    name="co_applicant"
                                                    value="agree" 
                                                    id="co_applicant_chk"
                                                />
                                                <label htmlFor="co_applicant_chk" >Check If Co-Applicant</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Trade-In Vehicle Information</div>
                                    <div className='row mlr-40'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Type</div>
                                                </div>
                                                <FinanceDropDown field={'trade_in_type'} />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='cs-label fw-300 mb-0'>Vehicle Status</div>
                                                </div>
                                                <FinanceDropDown field={'trade_in_vehicle_status'} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Vehicle of Interest</div>
                                    <div className='row mlr-40'>
                                        <div className='col-md-6'>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                            <div className='cs-label fw-300 mb-0'>Vehicle Make</div>
                                                        </div>
                                                        <Field as="select" name='vehicle_make' className='form-control'
                                                            onChange={(e) => { setFieldValue('vehicle_make',e.target.value); getVehicleModels(values.year,e.target.value); }}
                                                        >
                                                            <option>Select</option>
                                                            {vehicleMakes.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name='vehicle_make' component='div' className='text-danger' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                            <div className='cs-label fw-300 mb-0'>Model</div>
                                                        </div>
                                                        <Field as="select" name='vehicle_model' className='form-control'>
                                                            <option>Select</option>
                                                            {vehicleModels.map((v, i) => (
                                                                <option key={i} value={v}>
                                                                    {v}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        <ErrorMessage name='vehicle_model' component='div' className='text-danger' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row mlr-20'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                            <div className='cs-label fw-300 mb-0'>Stock #</div>
                                                        </div>
                                                        <Field type="text" name='vehicle_stock' className='form-control' />
                                                        <ErrorMessage name='vehicle_stock' component='div' className='text-danger' />
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                                            <div className='cs-label fw-300 mb-0'>Down Payment</div>
                                                        </div>
                                                        <Field type="text" name='vehicle_down_payment' className='form-control' />
                                                        <ErrorMessage name='vehicle_down_payment' component='div' className='text-danger' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Additional Information</div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label fw-300 mb-0'>Comments</div>
                                        </div>
                                        <Field type="text" name='comments' className='form-control h-100px' />
                                        <ErrorMessage name='comments' component='div' className='text-danger' />
                                    </div>
                                </div>
                                
                                <hr className='custom-hr2 m-0'/>
                                <div className='form-black-box pt-4 pb-2'>
                                    <div className='xs-title text-orange text-uppercase mb-3'>Terms And Conditions</div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-4'>
                                            <div className='cs-label fw-300 mb-0'>ACKNOWLEDGMENT AND CONSENT: I certify that the above information is complete and accurate to the best of my knowledge. Creditors receiving this application will retain the application whether or not it is approved. Creditors may rely on this application in deciding whether to grant the requested credit. False statements may subject me to criminal penalties. I authorize the creditors to obtain credit reports about me on an ongoing basis during this credit transaction and to check my credit and employment history on an ongoing basis during the term of the credit transaction. If this application is approved, I authorize the creditor to give credit information about me to its affiliates.</div>
                                        </div>
                                        <div className='fa-text-box'>
                                            <p>If you're a resident of California, Maine, Massachusetts, New York, Ohio, Rhode Island, Vermont, Washington, or Wisconsin, please scroll down to read the notice called for under the law of your state. By submitting this application, you represent that you've read the notice required under the law of your state.
</p>
                                            <p>CALIFORNIA RESIDENTS: A married applicant may apply for an individual account.
</p>
                                            <p>MAINE RESIDENTS: Consumer reports (credit reports) may be obtained in connection with this application. If you request, the creditor will inform you: whether or not consumer reports were obtained, and if reports were obtained, the names and addresses of the consumer reporting agencies (credit bureaus) that furnished the reports.
</p>
                                            <p>You have the right to choose the agent and insurer for the insurance required by this transaction, but the insurer must be approved by the creditor.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-md-flex'>
                                    <div className='mnw-150'>
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="terms_agreement"
                                                id="iAgreeChk"
                                            />
                                            <label htmlFor="iAgreeChk" >I agree</label>
                                        </div>
                                        <ValidationError name="terms_agreement"/>
                                    </div>
                                    <div className='cs-label'>* By checking this box you acknowledge that you have read, understand, and agree to the terms and conditions above. You also acknowledge that you have been provided access to, read, and understand our Privacy Policy.</div>
                                </div>
                                <div className='d-md-flex'>
                                    <div className='mnw-150'>
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="marketing_agreement"
                                                id="iAgreeChk2"
                                            />
                                            <label htmlFor="iAgreeChk2" >I agree</label>
                                        </div>
                                        <ValidationError name="marketing_agreement"/>
                                    </div>
                                    <div className='cs-label'>Yes, I agree to receive marketing/promotional SMS messages from McLaren Orlando, including special offers, exclusive incentives, event invitations, and dealership news.</div>
                                </div>
                                <div className='d-md-flex'>
                                    <div className='mnw-150'>
                                        <div className="custom-checkbox fin_app_chkbox mb-4">
                                            <Field
                                                type="checkbox"
                                                name="marketing_info_agreement"
                                                id="iAgreeChk3"
                                            />
                                            <label htmlFor="iAgreeChk3" >I agree</label>
                                        </div>
                                        <ValidationError name="marketing_info_agreement"/>
                                    </div>
                                    <div className='cs-label'>Yes, I agree to receive informational/transactional SMS messages from McLaren Orlando, such as appointment reminders, service updates, vehicle status notifications, and important account-related information.</div>
                                </div>
                                <div className='d-md-flex'>
                                    <div className='cs-label custom-breadcrumb'>
                                        By providing your mobile number and checking the above box/es, you agree to related text messages from McLaren Orlando at the phone number you provided when signing up. Reply STOP to unsubscribe, Reply HELP for help. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. For more information, please review our Privacy Policy <Link to="https://cars.mclaren.com/us_en/privacy-policy">Privacy Policy</Link> and <Link to="https://cars.mclaren.com/us_en/terms-conditions">Terms of Service</Link>
                                    </div>
                                </div>
                                <div className='text-md-end text-center mt-4'>
                                    <button type='submit' className='theme-btn text-uppercase lg-btn w-320 text-uppercase'>Apply</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default FinanceApplicationModal